import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../utlils/axios";
import { dispatch } from "../index"
import { handleSnackbar } from "../../utlils/snackbar";

export interface Users {
    userId?: string | number,
    loginName: string,
    loginPassword?: string,
    firstName: string,
    lastName: string,
    emailId: string,
    mobileNo: string,
    employeeCode: string,
    isAdmin: boolean,
    isActive: boolean,
    modelCodeAccess: string
}

export interface resetUserPasswordState {
    userId: string,
    newPassword: string
}

export interface changePasswordState {
    oldPassword: string,
    newPassword: string
}

type companyNameState = string

interface StateValues {
    usersDetials: Users[]
    singleUserDetail: undefined | Users
    addUserDetailData: Users | {}
    updateUserDetailData: Users | {}
    resetUserPasswordData: resetUserPasswordState
    loggedInUserDetail: undefined | Users
    changePasswordDetail: changePasswordState
    companyName: companyNameState
    allModelList: []
}

const initialState: StateValues = {
    usersDetials: [],
    allModelList: [],
    singleUserDetail: undefined,
    addUserDetailData: {},
    updateUserDetailData: {},
    resetUserPasswordData: {
        userId: "",
        newPassword: ""
    },
    loggedInUserDetail: undefined,
    changePasswordDetail: {
        oldPassword: "",
        newPassword: ""
    },
    companyName: ""
}

const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {
        getUserListData(state, action) {
            state.usersDetials = action.payload
        },
        getSingleUserData(state, action) {
            state.singleUserDetail = action.payload
        },
        addUserDetailData(state, action) {
            state.addUserDetailData = action.payload
        },
        updateUserDetail(state, action) {
            state.updateUserDetailData = action.payload
        },
        resetUserPasswordDetails(state, action) {
            state.resetUserPasswordData = action.payload
        },
        getLoggedInUserData(state, action) {
            state.loggedInUserDetail = action.payload
        },
        changePasswordData(state, action) {
            state.changePasswordDetail = action.payload
        },
        getCompanyNameData(state, action) {
            state.companyName = action.payload
        },
        getAllModelListData(state, action) {
            state.allModelList = action.payload
        }
    }
})

export default userSlice.reducer

//Get Users List 
export const getUserList = () => {
    return async () => {
        const url = "/user/list"
        try {
            const response = await axios.get(url)
            dispatch(userSlice.actions.getUserListData(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Company Name 
export const getCompanyName = () => {
    return async () => {
        const url = "/dashboard/company-name"
        try {
            const response = await axios.get(url)
            dispatch(userSlice.actions.getCompanyNameData(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get All Model List Name 
export const getAllModelList = (companyId: string | number = "") => {
    return async () => {
        const url = `/setup/models/${String(companyId)}`
        try {
            const response = await axios.get(url)
            dispatch(userSlice.actions.getAllModelListData(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Single User Detail
export const getSingleUserDetail = (userId: string) => {
    return async () => {
        const url = `/user/${userId}`
        try {
            const response = await axios.get(url)
            dispatch(userSlice.actions.getSingleUserData(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Add a User 
export const addUserDetail = (payload: Users) => {
    return async () => {
        const url = "/user"
        try {
            const response = await axios.post(url, payload)
            dispatch(userSlice.actions.addUserDetailData(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Edit a User 
export const updateUserDetails = (payload: Users) => {
    return async () => {
        const url = `/user/${payload.userId}`
        try {
            const response = await axios.put(url, payload)
            dispatch(userSlice.actions.updateUserDetail(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Reset User Password 
export const resetUserPassword = (payload: resetUserPasswordState) => {
    return async () => {
        const url = '/user/reset-password'
        try {
            const response = await axios.post(url, payload)
            dispatch(userSlice.actions.resetUserPasswordDetails(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get loggedIn User Detail
export const getLoggedInUserDetail = (userId: string) => {
    return async () => {
        const url = `/user/${userId}`
        try {
            const response = await axios.get(url)
            dispatch(userSlice.actions.getLoggedInUserData(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Change User Password 
export const changePassword = (payload: changePasswordState) => {
    return async () => {
        const url = '/user/change-password'
        try {
            const response = await axios.post(url, payload)
            dispatch(userSlice.actions.changePasswordData(response.data))
            dispatch(handleSnackbar(response?.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}
